// extracted by mini-css-extract-plugin
export default {"messageWrapper":"nN9B4i","message":"u5tvLZ","messageAlert":"sMD2uj"};